import React, { useState, useEffect } from "react";
import "./transactiondetails.css";
import DataTable from "react-data-table-component";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../../constants/constants";
import { adminConfig } from "../../../utils/adminConfig";

const columns = [
  // {
  //   name: "id",
  //   selector: (row) => row.id,
  //   sortable: true,
  //   width: "100px",
  // },
  {
    name: "Purchaser's information",
    // selector: (row) => row.name,
    cell: (row) => {
      return (
        <div>
          <p>Name : {row.name}</p> <p>Email : {row.email}</p>
        </div>
      )
    },
    sortable: true,
    width: "300px",
  },
  {
    name: "Date",
    selector: (row) => moment(row.date).format(DATE_TIME_FORMAT),
    sortable: true,
    width: "250px",
  },
  {
    name: "Amount",
    selector: (row) => "$" + row.amount,
    sortable: true,
    width: "150px",
  },
  {
    name: "Certificate  ID",
    selector: (row) => row.certificateId,
    sortable: true,
    width: "160px",
  },
  {
    name: "Charge ID",
    selector: (row) => row.chargeId,
    sortable: true,
    width: "160px",
  },
  {
    name: "Transaction ID",
    selector: (row) => row.transactionId,
    sortable: true,
    width: "160px",
  },
  {
    name: "Payment Method",
    selector: (row) => row.paymentMethod,
    sortable: true,
    width: "400px",
  },
  {
    name: "Receipt Url",
    selector: (row) => row.receipt_url,
    cell: (row) =>
      row.receipt_url ? (
        <a href={row.receipt_url} className="btn btn-primary" target="_blank" rel="noopener noreferrer">
          View Receipt
        </a>
      ) : (
        ""
      ),
    sortable: true,
    width: "150px",
  },
  {
    name: "Sent from",
    // selector: (row) => row.emailSentFrom,
    cell: (row) => {
      return (
        <div>
          <p>Name : {row.nameSentFrom}</p> <p>Email : {row.emailSentFrom}</p>
          <p>UserName : {row.userNameSentFrom}</p>
        </div>
      )
    },
    sortable: true,
    width: "300px",
  },
  {
    name: "Status",
    selector: (row) => row.status,
    sortable: true,
    width: "140px",
  },
];

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const TransactionDetails = () => {
  let token = localStorage.getItem("AuthToken");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 5,
    page: 1,
    totalPage: 7,
    totalRows: 10,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [csvData, setCsvData] = useState([]);

  const allMembers = () => {
    let allMembers = members?.map((item, i) => {
      return {
        id: i + 1,
        name: item.name,
        email: item.email,
        certificateId: item.certificateId,
        chargeId: item.chargeId,
        date: item.createdAt,
        transactionId: item.transactionId,
        amount: item.amount,
        paymentMethod: item.paymentMethod,
        receipt_url: item.receipt_url,
        emailSentFrom: item.userDetails?.email,
        nameSentFrom: item.userDetails?.name,
        failure_message: item.failure_message,
        userNameSentFrom: item.userDetails?.userName,
        status: (
          <div
            className={
              item.status == "succeeded"
                ? "status_tran compl"
                : "status_tran icompl"
            }
          >
            {item.status}
          </div>
        ),
      };
    });
    return allMembers;
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);

    setPage(page);
  };

  const getMembers = (filters = {}) => {
    setLoading(true);
    const query = new URLSearchParams({
      limit: limit.toString(),
      page: page.toString(),
      ...(filters.startDate ? { startDate: filters.startDate } : {}),
      ...(filters.endDate ? { endDate: filters.endDate } : {}),
      ...(startDate && !filters.startDate ? { startDate } : {}),
      ...(endDate && !filters.endDate ? { endDate } : {}),
    }).toString();

    axios
      .post(`/all-payments/?${query}`, adminConfig())
      .then((res) => {
        if (res.data.status === true && res.data.data.length > 0) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);

          setLoading(false);
          // message.success("fetched member success");
        } else {
          message.error("Data Not Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleSearch = () => {

    //if both dates are not selected then show error
    if (!startDate || !endDate) {
      message.error("Please select both dates");
      return;
    }
    setPage(1);
    getMembers({ startDate, endDate });
  };

  const changePage = (newPage) => {
    setLoading(true);
    setPage(newPage);
  };

  useEffect(() => {
    getMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  const exportCSV = () => {
    setLoading(true);
    //if filters are applied then pass the filters in the request
    const filters = {};
    if (startDate) filters.startDate = startDate;
    if (endDate) filters.endDate = endDate;

    axios
      .get(`/all-csv-payments`, { params: filters })
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            ID: member.id,
            Name: member.name,
            Email: member.email,
            CertificateId: member.certificateId,
            ChargeId: member.chargeId,
            TransactionId: member.transactionId,
            Date: moment(member.date).format("MM-DD-YYYY"),
            Amount: member.amount,
            PaymentMethod: member.paymentMethod,
            ReceiptUrl: member.receipt_url,
            EmailSentFrom: member.userDetails?.email,
            NameSentFrom: member.userDetails?.name,
            UserNameSentFrom: member.userDetails?.userName,
            Status: member.status,
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    // { label: "ID", key: "ID" },
    { label: "Purchaser's Name", key: "Name" },
    { label: "Purchaser's Email", key: "Email" },
    { label: "Date", key: "Date" },
    { label: "Amount", key: "Amount" },
    { label: "Certificate Id", key: "CertificateId" },
    { label: "Charge Id", key: "ChargeId" },
    { label: "Transaction Id", key: "TransactionId" },
    { label: "Payment Method", key: "PaymentMethod" },
    { label: "Receipt Url", key: "ReceiptUrl" },
    { label: "Sent From Email", key: "EmailSentFrom" },
    { label: "Sent From Name", key: "NameSentFrom" },
    { label: "Sent From UserName", key: "UserNameSentFrom" },
    { label: "Status", key: "Status" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>Transaction Details</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>

                <div className="filter_section">
                  <div className="filter_btns d-flex align-items-end justify-content-between" style={{ gap: "10px", width: "100%" }}>
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                      <Button
                        className="btn btn-primary search_button"
                        onClick={exportCSV}
                      >
                        Export CSV
                      </Button>
                      <CSVLink
                        data={csvData}
                        headers={csvHeaders}
                        filename={`transaction_details.csv`}
                        className="hidden"
                        id="csv-download-link"
                        target="_blank"
                      />
                    </div>
                    <div className="d-flex align-items-end" style={{ gap: "10px" }}>
                      <div>
                        <label>Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div>
                        <label>End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                      <Button
                        className="btn btn-primary search_button"
                        onClick={handleSearch}
                      >
                        Search
                      </Button>
                    </div>
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={allMembers()}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
};
const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);
export default TransactionDetails;
